import TelegramIcon from '@mui/icons-material/Telegram';
import { Box, Button, Paper, Typography } from '@mui/material';

const TelegramPanel = () => {
    return (
        <Box>
            <Paper
                sx={{
                    p: 4,
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0, 136, 204, 0.2)',
                }}
            >
                <TelegramIcon sx={{ fontSize: 80, color: '#0088cc', mb: 2 }} />
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#075985' }}>
                    Telegram интеграция
                </Typography>
                <Typography variant="body1" sx={{ color: '#0c4a6e', mb: 3, maxWidth: 600, mx: 'auto' }}>
                    Здесь будет интеграция с Telegram для автоматизации общения с клиентами,
                    рассылок уведомлений и управления ботом.
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        bgcolor: '#0088cc',
                        '&:hover': { bgcolor: '#0077b3' },
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                    }}
                >
                    Настроить интеграцию
                </Button>
            </Paper>
        </Box>
    );
};

export default TelegramPanel;
